export const RESPONSAVEIS_LIST = 'RESPONSAVEIS_LIST';
export const RESPONSAVEIS_LIST_START = 'RESPONSAVEIS_LIST_START';
export const RESPONSAVEIS_LIST_SUCCESS = 'RESPONSAVEIS_LIST_SUCCESS';
export const RESPONSAVEIS_LIST_ERROR = 'RESPONSAVEIS_LIST_ERROR';
